import { render, staticRenderFns } from "./EnacAtplDashboardNotificationProcedure.vue?vue&type=template&id=293e9ff6"
import script from "./EnacAtplDashboardNotificationProcedure.vue?vue&type=script&lang=js"
export * from "./EnacAtplDashboardNotificationProcedure.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports